import React from "react";
import { Calendar } from "./date-picker";
import "./calender.css";

const DateInput = ({
  value = {
    year: new Date().getFullYear(),
    month: new Date().getMonth(),
    day: new Date().getDate(),
  },
  onChange = () => {},
  className,
}) => {
  return (
    <div className={className}>
      <Calendar value={value} onChange={onChange} shouldHighlightWeekends />
    </div>
  );
};

export default DateInput;
